export default __webpack_public_path__ + "static/media/cross-icon.7adb805b.svg";